import _ from "underscore";

export default function sortReferences(list) {
  return _.sortBy(list, item => {
    return item;
  });
}
